// src/components/InstallPWA.tsx
import React, { useEffect, useState } from 'react';
import { FaDownload, FaTimes } from 'react-icons/fa';

const InstallPWA: React.FC = () => {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState<any>(null);
  const [isInstalled, setIsInstalled] = useState(false);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    // Vérifie si l'app est déjà installée (en mode standalone)
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsInstalled(true);
      return;
    }

    const handler = (e: Event) => {
      e.preventDefault();
      setSupportsPWA(true);
      setPromptInstall(e);
      
      // On attend 3 secondes avant d'afficher le popup pour ne pas agresser l'utilisateur
      setTimeout(() => setShowPrompt(true), 3000);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const onClickInstall = async () => {
    if (!promptInstall) return;
    promptInstall.prompt();
    const { outcome } = await promptInstall.userChoice;
    if (outcome === 'accepted') {
      setShowPrompt(false);
    }
  };

  if (!supportsPWA || isInstalled || !showPrompt) {
    return null;
  }

  return (
    <div className="fixed bottom-24 left-4 right-4 md:left-auto md:right-8 md:w-96 bg-white p-4 rounded-2xl shadow-2xl border border-purple-100 z-50 animate-in slide-in-from-bottom-8">
      <button 
        onClick={() => setShowPrompt(false)} 
        className="absolute top-2 right-2 text-slate-400 hover:text-slate-600 p-2"
      >
        <FaTimes />
      </button>
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center text-purple-600 shrink-0">
          <img src="/logo.png" alt="Forfeo" className="w-8 h-8 object-contain rounded-lg" onError={(e) => e.currentTarget.style.display = 'none'} />
        </div>
        <div className="flex-1 pr-6">
          <h4 className="font-black text-slate-900 text-sm leading-tight">Ajouter Forfeo à l'écran d'accueil</h4>
          <p className="text-xs text-slate-500 mt-0.5">Plus rapide et sans publicité.</p>
        </div>
      </div>
      <button 
        onClick={onClickInstall}
        className="mt-4 w-full bg-purple-600 text-white py-3 rounded-xl font-black uppercase text-xs tracking-widest hover:bg-purple-700 transition flex items-center justify-center gap-2 shadow-lg shadow-purple-500/30"
      >
        <FaDownload size={14}/> Installer l'Application
      </button>
    </div>
  );
};

export default InstallPWA;
